import React from 'react';
import PropTypes from 'prop-types';

import { I18nProvider } from 'lingui-react';
import { unpackCatalog } from 'lingui-i18n';

import getBrowserLocale from 'utils/browserLocale';

import catalogDE from 'locale/de/messages';
import catalogEN from 'locale/en/messages';
import catalogES from 'locale/es/messages';
import catalogJA from 'locale/ja/messages';
import catalogNL from 'locale/nl/messages';

// ----------------------------------------------------------------------

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
/* istanbul ignore next */
const userLocale = getBrowserLocale();

// Split locales with a region code
const languageWithoutRegionCode = userLocale.toLowerCase().split(/[_-]+/)[0];

// ----------------------------------------------------------------------
// new js-lingui translation setup:

const linguiCatalogs = {
  de: unpackCatalog(catalogDE),
  en: unpackCatalog(catalogEN),
  es: unpackCatalog(catalogES),
  ja: unpackCatalog(catalogJA),
  nl: unpackCatalog(catalogNL),
};

// required for JS-Lingui in development only (huge dependency)
// eslint-disable-next-line global-require
const jsLinguiDev = process.env.NODE_ENV !== 'production' && require('lingui-i18n/dev');

function I18n({ language, children }) {
  return (
    <I18nProvider
      language={language}
      development={jsLinguiDev}
      catalogs={linguiCatalogs}
    >
      {children}
    </I18nProvider>
  );
}

I18n.propTypes = {
  language: PropTypes.string,
  children: PropTypes.node.isRequired,
};

I18n.defaultProps = {
  locale: userLocale,
  language: languageWithoutRegionCode,
};

export default I18n;



// WEBPACK FOOTER //
// ./setup/I18n/index.js